angular.module('SpidApp')

.factory('InventoryService',
		['Inventory', 'Restangular',
function (Inventory,   Restangular) {
	var InventoryService = {
		
		// GET: /agencies/{agency_id}/inventories
		findByAgencyId: function (agencyId) {
			if (!agencyId) {
				throw 'InventoryService::findByAgencyId() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).all('inventories').getList().then(function (datas) {
				return _.chain(datas).map(function (data) {
					return new Inventory(data)
				}).sortBy('updated_at').value();
			})
		},
		
		// GET: /agencies/{agency_id}/inventories/{inventory_id}
		findByAgencyIdAndInventoryId: function(agencyId, inventoryId) {
			if (!agencyId || !inventoryId) {
				throw 'InventoryService::findByAgencyId() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).one('inventories', inventoryId).get().then(function (data) {
				return new Inventory(data);
			})
		},
		
		// POST: /agencies/{agency_id}/users/{user_id}/inventories
		save: function(inventory, agencyId, userId) {
			if (!inventory || !agencyId || !userId) {
				throw 'InventoryService::save() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).one('users', userId).all('inventories').post(inventory);
		},
		
		bulkSave : function(inventories, agencyId, userId) {
			if (!inventories || !agencyId || !userId) {
				throw 'InventoryService::bulkSave() - Missing parameters'
			}
			
			return Restangular.one('agencies', agencyId).one('users', userId).all('inventories').post(inventories);
		}
	}

	return InventoryService
}])